import { OperandOption, IProblemGenerator } from "./sharedTypes";

export type DivisionOptions = {
    operand1?: OperandOption;
    operand2?: OperandOption;
    progression?: boolean;
    progressionRate?: number;
}

const DEFAULT_MAX_OPERAND = 9;

export default class DivisionProblemGenerator implements IProblemGenerator {
    private options?: DivisionOptions;
    private currentStreak: number;
    private lastOperandIncreased: 1 | 2;

    constructor(options: DivisionOptions) {
        this.currentStreak = 0;
        this.lastOperandIncreased = 1;

        let have1 = false;
        let have2 = false;

        let op1 = {};
        let op2 = {};

        if (options?.operand1?.min) {
            Object.assign(op1, { min: options.operand1.min });
            have1 = true;
        }
        if (options?.operand1?.max) {
            Object.assign(op1, { max: options.operand1.max });
            have1 = true;
        }
        if (options?.operand2?.min) {
            Object.assign(op2, { min: options.operand2.min });
            have2 = true;
        }
        if (options?.operand2?.max) {
            Object.assign(op2, { max: options.operand2.max });
            have2 = true;
        }

        this.options = options;

    }
    getNext() {
        const op1Range = (this?.options?.operand1?.max??DEFAULT_MAX_OPERAND) - (this?.options?.operand1?.min??1)
        const op2Range = (this?.options?.operand2?.max??DEFAULT_MAX_OPERAND) - (this?.options?.operand2?.min??1)

        const op1 = Math.round(Math.random() * op1Range + (this?.options?.operand1?.min??1))
        const op2 = Math.round(Math.random() * op2Range + (this?.options?.operand2?.min??1))

        return {
            generator: "Division",
            display: `${op1 * op2} ÷ ${op2}`,
            userAnswer: undefined,
            correctAnswer: op1
        }
    }
    reportResult(wasCorrect: boolean, userAnswer: number) {
        if (this.options?.progression === true) {

            if (wasCorrect) {
                this.currentStreak += 1;
                //console.log(`Current Streak: ${this.currentStreak}`);
            } else {
                this.currentStreak = 0;
            }

            if (this.currentStreak >= (this.options?.progressionRate ?? 10)) {
                
                if (this.lastOperandIncreased === 1) {
                    if (this.options?.operand2?.max)
                        this.options.operand2.max = this.options?.operand2?.max + 1;
                    if (this.options?.operand2?.min)
                        this.options.operand2.min += 1;
                } else {
                    if (this.options?.operand1?.max)
                        this.options.operand1.max = this.options?.operand1?.max + 1;
                    if (this.options?.operand1?.min)
                        this.options.operand1.min += 1;
                }

                console.log(`Increasing division difficulty`, this.options)
                this.lastOperandIncreased = this.lastOperandIncreased === 2 ? 1 : 2;
                this.currentStreak = 0;
            }
        }
    }
}